module.exports = __webpack_public_path__ + "img/pass.6ca44a52.png";